import { PageImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/pageImpression.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsPageImpression
    extends GoogleAnalyticsMinimumDataset {}

const getGoogleAnalyticsPageImpression = (
    data: TypedAnalyticsEvent<PageImpressionTrackingInfo>
): GoogleAnalyticsPageImpression => {
    return {
        event: GoogleAnalyticsEvents.PageImpression,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data)
    };
};

export { getGoogleAnalyticsPageImpression };
